import {
  BaseGtmEvent,
  CartEvent,
  ClearEcommerceEvent,
  GTM_LIST_NAME,
  GtmEventType,
  GtmNavigationEvent,
  GtmSearchEvent
} from 'store/googleTagManager/types';
import { PageState } from 'models/PageState';
import { getClearEcommerceEvent } from 'store/googleTagManager/events/genericEvents';
import { mapCartToGtm } from 'store/googleTagManager/events/utils';
import { GtmSearchAction, GtmInternalNavAction } from 'store/googleTagManager/actions';
import { AppShellManifest } from 'models/AppShellManifest';

export const getClearCartEvent = (): BaseGtmEvent => {
  return {
    event: 'clear_cart'
  };
};

export const getViewCartEvent = ({
  cart,
  appShell
}: PageState): [ClearEcommerceEvent, CartEvent] => {
  const items = mapCartToGtm(cart, GTM_LIST_NAME.CART, true);
  const value = items.reduce((sum, { quantity, price }) => sum + quantity * price, 0);

  return [
    getClearEcommerceEvent(),
    {
      event: 'view_cart',
      ecommerce: {
        currency: appShell.currencyCode,
        value: value,
        items: items
      }
    }
  ];
};

export const getSearchEvent = ({ search_type, search_term }: GtmSearchAction): GtmSearchEvent => {
  return {
    event: 'search',
    search_term,
    search_type
  };
};

export const getNavigationEvent = (
  { link_url }: GtmInternalNavAction,
  { links }: AppShellManifest,
  event: GtmEventType
): GtmNavigationEvent => {
  const fullUrl = links.site + link_url;

  return {
    event,
    link_url: fullUrl
  };
};
